const data = {
  'Selected': 'Marcat: {0} din {1}',
  'Uploading files': 'Se încarcă {0}% din {1}',
  'File size error': '{0} este prea mare, încărcați fișiere mai mici decât {1}',
  'Upload failed': '{0} a eșuat să se încarce',
  'Upload summary': '{0} reușite, {1} eșuate, {2} în total',
  'Per page': '{0} Per Pagină',
  'Folder': 'Dosar',
  'Login failed, please try again': 'Autentificare eșuată, încercați din nou',
  'Already logged in': 'Deja autentificat.',
  'Please enter username and password': 'Introduceți numele de utilizator și parola.',
  'Not Found': 'Negăsit',
  'Not Allowed': 'Nepermis',
  'Please log in': 'Autentificați-vă',
  'Unknown error': 'Eroare necunoscută',
  'Add files': 'Adaugă fișiere',
  'New': 'Nou',
  'New name': 'Nume nou',
  'Username': 'Nume utilizator',
  'Password': 'Parola',
  'Login': 'Autentificare',
  'Logout': 'Deconectare',
  'Profile': 'Profil',
  'No pagination': 'Fără paginare',
  'Time': 'Timp',
  'Name': 'Nume',
  'Size': 'Dimensiune',
  'Home': 'Acasă',
  'Copy': 'Copiere',
  'Move': 'Mutare',
  'Rename': 'Redenumire',
  'Required': 'Completați acest câmp',
  'Zip': 'Zip',
  'Batch Download': 'Descărcare grupată',
  'Unzip': 'Unzip',
  'Delete': 'Ștergere',
  'Download': 'Descărcare',
  'Copy link': 'Copiere adresă',
  'Done': 'Finalizat',
  'File': 'Fișier',
  'Drop files to upload': 'Aruncați aici fișierul pentru încărcare',
  'Close': 'Închidere',
  'Select Folder': 'Alege dosar',
  'Users': 'Utilizatori',
  'Files': 'Fișiere',
  'Role': 'Rol',
  'Cancel': 'Anulare',
  'Paused': 'Suspendat',
  'Confirm': 'Confirmare',
  'Create': 'Creare',
  'User': 'Utilizator',
  'Admin': 'Admin',
  'Save': 'Salvare',
  'Read': 'Citire',
  'Write': 'Scriere',
  'Upload': 'Încărcare',
  'Permissions': 'Permisiuni',
  'Homedir': 'Dosar acasă',
  'Leave blank for no change': 'Lăsați liber pentru nici o schimbare',
  'Are you sure you want to do this?': 'Sunteți sigur că doriți să faceți asta?',
  'Are you sure you want to allow access to everyone?': 'Sunteți sigur că doriți să permiteți accesul tuturor?',
  'Are you sure you want to stop all uploads?': 'Sunteți sigur că doriți oprirea tuturor încărcărilor?',
  'Something went wrong': 'Ceva a mers greșit',
  'Invalid directory': 'Dosar invalid',
  'This field is required': 'Acest câmp este obligatoriu',
  'Username already taken': 'Nume de utilizator deja luat',
  'User not found': 'Utilizator negăsit',
  'Old password': 'Parola veche',
  'New password': 'Parola nouă',
  'Wrong password': 'Parolă greșită',
  'Updated': 'Modificat',
  'Deleted': 'Șters',
  'Your file is ready': 'Fișierul este pregătit',
  'View': 'Vizualizare',
  'Search': 'Căutare',
  'Download permission': 'Descărcare',
  'Guest': 'Oaspete',
  'Show hidden': 'Arată ascunse',
  'Show symbolic format': 'Afișează formatul simbolic',
  'Hide symbolic format': 'Ascunde formatul simbolic',
}

export default data

